var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computedFrom } from "aurelia-binding";
import { bindable } from "aurelia-templating";
import { Guid } from "../../../../utilities/guid";
import { autoinject, transient } from "aurelia-dependency-injection";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { LookupValueRequest, LookupValue } from "../../../../models/lookups/lookup.models";
import { Reflection } from "../../../../utilities/reflection";
import * as Enumerable from "linq";
var LookupControl = /** @class */ (function () {
    function LookupControl(element, lookupsClientService) {
        var _this = this;
        this.element = element;
        this.lookupsClientService = lookupsClientService;
        this.count = 0;
        this.parameters = "";
        this.placeholder = "";
        this.noItemOptionLabel = null;
        this.info = "";
        this.shouldCache = true;
        this.hideIfNoData = false;
        this.excludeItemsById = [];
        this.itemSource = null;
        this.loadData = function () {
            if (!_this.isAttached)
                return;
            _this.count++;
            var localCount = _this.count;
            if (_this.query) {
                var lookupValueRequest = _this.createLookupValueRequest();
                _this.lookupsClientService.getLookup(lookupValueRequest, _this.shouldCache)
                    .then(function (response) {
                    if (localCount !== _this.count) {
                        return;
                    }
                    if (response) {
                        var cloneResponse = response.values.slice(0);
                        if (_this.selectDefault) {
                            cloneResponse = Enumerable.from(cloneResponse).orderByDescending(function (x) { return x.isDefault; }).toArray();
                        }
                        if (_this.noItemOptionLabel) {
                            var emptyLookup = {
                                id: null,
                                name: _this.noItemOptionLabel,
                                isActive: true,
                                isDefault: true,
                                isSelectable: true,
                                guid: Guid.generateGuid(),
                                additionalData: null,
                                children: null
                            };
                            cloneResponse.unshift(emptyLookup);
                        }
                        _this.itemSource = _this.valueConverter ? _this.valueConverter(cloneResponse) : cloneResponse;
                    }
                    else {
                        _this.itemSource = [];
                    }
                    setTimeout(function () {
                        var valuesLoadedEvent = new CustomEvent("values-loaded", { detail: { values: _this.itemSource.slice(0) }, bubbles: true });
                        _this.element.dispatchEvent(valuesLoadedEvent);
                    });
                }).catch(function (e) {
                    if (localCount !== _this.count) {
                        return;
                    }
                    console.error(e);
                    _this.itemSource = [];
                });
            }
        };
    }
    LookupControl.prototype.noItemOptionLabelChanged = function (newValue, oldValue) {
        var _this = this;
        if (this.itemSource && newValue && !this.itemSource.some(function (x) { return x.id == null && x.name == _this.noItemOptionLabel; })) {
            this.itemSource.unshift({
                id: null,
                name: this.noItemOptionLabel,
                isActive: true,
                isDefault: true,
                isSelectable: true,
                guid: Guid.generateGuid(),
                additionalData: null,
                children: null
            });
            if (!this.selectedValue) {
                this.selectedItem = this.itemSource[0];
            }
        }
    };
    LookupControl.prototype.selectedValueChanged = function (newValue, oldValue) {
        var _this = this;
        setTimeout(function () {
            var valueChangedEvent = new CustomEvent("selected-value-changed", {
                detail: { value: newValue },
                bubbles: true
            });
            _this.element.dispatchEvent(valueChangedEvent);
        });
    };
    LookupControl.prototype.selectedItemChanged = function (newValue, oldValue) {
        var _this = this;
        if (this.itemSource) {
            setTimeout(function () {
                var itemChangedEvent = new CustomEvent("selected-item-changed", {
                    detail: { item: newValue },
                    bubbles: true
                });
                _this.element.dispatchEvent(itemChangedEvent);
            });
        }
    };
    LookupControl.prototype.queryChanged = function (newValue, oldValue) {
        this.lookupsClientService.unsubscribeForLookupsRefresh(oldValue, this.parameters, this.loadData);
        this.lookupsClientService.subscribeForLookupsRefresh(newValue, this.parameters, this.loadData);
        this.loadData();
    };
    LookupControl.prototype.parametersChanged = function (newValue, oldValue) {
        this.lookupsClientService.unsubscribeForLookupsRefresh(this.query, oldValue, this.loadData);
        this.lookupsClientService.subscribeForLookupsRefresh(this.query, newValue, this.loadData);
        this.loadData();
    };
    Object.defineProperty(LookupControl.prototype, "itemSourceFiltered", {
        get: function () {
            var _this = this;
            var excludedIds = [];
            if (this.excludeItemsById && typeof this.excludeItemsById == "string") {
                excludedIds = this.excludeItemsById.split(',');
            }
            else if (this.excludeItemsById && typeof this.excludeItemsById == "number") {
                excludedIds = [this.excludeItemsById];
            }
            else if (Array.isArray(this.excludeItemsById)) {
                excludedIds = this.excludeItemsById;
            }
            var filtered;
            if (this.itemSource) {
                if (excludedIds && excludedIds.length > 0 && this.itemSource.length > 0) {
                    filtered = this.itemSource.filter(function (x) { return !excludedIds.some(function (y) { return y == x.id; }) || x.id == _this.selectedValue; });
                }
                else {
                    filtered = this.itemSource;
                }
            }
            else {
                filtered = null;
            }
            return (!filtered || (this.hideIfNoData && filtered.length == 0)) ? null : filtered;
        },
        enumerable: false,
        configurable: true
    });
    LookupControl.prototype.attached = function () {
        this.isAttached = true;
        this.loadData();
    };
    LookupControl.prototype.createLookupValueRequest = function () {
        var request = new LookupValueRequest();
        request.lookupValueQuery = this.query;
        request.parameters = this.parameters;
        return request;
    };
    LookupControl.prototype.detached = function () {
        this.lookupsClientService.unsubscribeForLookupsRefresh(this.query, this.parameters, this.loadData);
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupControl.prototype, "parameters", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupControl.prototype, "placeholder", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupControl.prototype, "noItemOptionLabel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], LookupControl.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupControl.prototype, "info", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], LookupControl.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], LookupControl.prototype, "shouldCache", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupControl.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], LookupControl.prototype, "selectDefault", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], LookupControl.prototype, "query", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], LookupControl.prototype, "hideIfNoData", void 0);
    __decorate([
        bindable,
        __metadata("design:type", LookupValue)
    ], LookupControl.prototype, "selectedItem", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], LookupControl.prototype, "excludeItemsById", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], LookupControl.prototype, "valueConverter", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], LookupControl.prototype, "selectedValue", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], LookupControl.prototype, "showOnAdorner", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], LookupControl.prototype, "tab", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.itemSource; }), Reflection.getPropertyPath(function (x) { return x.selectedValue; }), Reflection.getPropertyPath(function (x) { return x.excludeItemsById; }), Reflection.getPropertyPath(function (x) { return x.hideIfNoData; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], LookupControl.prototype, "itemSourceFiltered", null);
    LookupControl = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element, LookupClientService])
    ], LookupControl);
    return LookupControl;
}());
export { LookupControl };
